import LoginPage from './views/LoginPage';
import Logout from './components/Logout';
import UserProfile from './views/UserProfilePage';
import SaProfile from './views/SuperAdminProfilePage';
import Settings from './views/SettingsPage';
import HomePage from './views/Home/Home';
import DemosPage from './views/Demos';
import SpreadsheetUploadPage from './views/SpreadsheetUploadPage';
import FirmDownloadPage from './views/FirmDownloadPage';
import DemoPage from './views/DemoOverview';
import AccountsPage from './views/Accounts';
import AccountPage from './views/AccountOverview';
import DropdownPage from './views/DropdownEditor';
import LaunchDemoForm from './views/LaunchDemoForm';
import RegisterAccountForm from './views/RegisterAccountForm';
import TwilioInfoPage from './views/TwilioInfoPage';
import CallRailInfoPage from './views/CallRailInfoPage';
import NewProspectPage from './views/NewProspectPage';
import ProspectsPage from './views/ProspectsPage';
import ClientsPage from './views/ClientsPage';
import AlumPage from './views/AlumPage';
import ReferrerOrgsPage from './views/ReferrerOrgsPage';
import ReferrerOrgPage from './views/ReferrerOrgPage';
import ReferrerContactsPage from './views/ReferrerContactsPage';
import ReferrerContactPage from './views/ReferrerContactPage';
import EmergencyContactPage from './views/EmergencyContactPage';
import CampaignsPage from './views/CampaignsPage';
import InquiriesPage from './views/InquiriesPage';
import CasePage from './views/CasePage';
import ShowClientPage from './views/ShowClientPage';
import ReferralPage from './views/ReferralPage';
import InquiryPage from './views/InquiryPage';
import CallLogPage from './views/CallLogPage';
import AllevaPlay01Page from './views/AllevaPlay01Page';
import KimsExperimentPage from './views/KimsExperimentPage';
import LayoutPractice01 from './views/LayoutPractice01';
import DevMode from './components/DevMode';
import ClearStoragePage from './views/ClearStoragePage';
import ConfigureEmrSyncPage from './views/ConfigureEmrSyncPage';
import ReferralReportPage from './views/ReferralReportPage';
import ActivityReportPage from './views/ActivityReportPage';

// @mui/icons-material
import HomeIcon from '@mui/icons-material/Home';
import DevModeIcon from '@mui/icons-material/FlashOn';
import ClearStorageIcon from '@mui/icons-material/LayersClearSharp';
import CallFormIcon from '@mui/icons-material/Phone';
import PeopleIcon from '@mui/icons-material/People';
import PersonIcon from '@mui/icons-material/Person';
import AlumIcon from '@mui/icons-material/School';
import ReferrersIcon from '@mui/icons-material/SwapHoriz'; // or Shuffle
import CampaignsIcon from '@mui/icons-material/VolumeUp'; // or ImportantDevices
import InquiriesIcon from '@mui/icons-material/RingVolume'; // or ChatBubbleOpen, or Inbox
import LeadsIcon from '@mui/icons-material/CameraFrontSharp';
import ReportsIcon from '@mui/icons-material/ListAlt';
import CaseIcon from '@mui/icons-material/BusinessCenter';
import PlayIcon from '@mui/icons-material/Pool';
import PracticeIcon from '@mui/icons-material/School';
import LoginIcon from '@mui/icons-material/ExitToApp';

const tempLayout = '/dev';

const homeRoute = {
  path: '/home',
  name: 'Home',
  rtlName: 'هعذاتسجيل الدخول',
  icon: HomeIcon,
  component: HomePage,
  excludeFooter: true,
  layout: tempLayout,
};

const strangerHomeRoute = {
  path: '/home',
  name: 'Alleva CRM',
  icon: HomeIcon,
  component: HomePage,
  layout: tempLayout,
};

const loginRoute = {
  path: '/login',
  name: 'Login', // don't show this
  // rtlName: 'لوحة القيادة',
  hideName: true,
  icon: LoginIcon,
  component: LoginPage,
  excludeFooter: true,
  layout: tempLayout,
};

const logoutRoute = {
  path: '/logout',
  name: 'Logout',
  invisible: true,
  component: Logout,
  layout: tempLayout,
};

const userProfileRoute = {
  path: '/userProfile',
  name: 'User Profile',
  icon: PersonIcon,
  invisible: true,
  component: UserProfile,
  layout: tempLayout,
};

const saProfileRoute = {
  path: '/saProfile',
  name: 'SuperAdmin Profile',
  icon: PersonIcon,
  invisible: true,
  component: SaProfile,
  layout: tempLayout,
};

const settingsRoute = {
  path: '/settings',
  name: 'Settings',
  invisible: true,
  component: Settings,
  layout: tempLayout,
};

const devModeRoute = {
  path: '/devMode',
  name: 'Dev Mode',
  rtlName: 'لوحة القيادة',
  icon: DevModeIcon,
  component: DevMode,
  layout: tempLayout,
};

const clearStorageRoute = {
  path: '/clearStorage',
  name: 'Clear Storage',
  icon: ClearStorageIcon,
  component: ClearStoragePage,
  layout: tempLayout,
};

const demosRoute = {
  path: '/demos',
  name: 'Demos',
  rtlName: 'لوحة القيادة',
  invisible: true,
  component: DemosPage,
  layout: tempLayout,
};

const spreadsheetUploadRoute = {
  path: '/uploadSpreadsheet',
  name: 'Upload Spreadsheet',
  invisible: true,
  component: SpreadsheetUploadPage,
  layout: tempLayout,
};

const downloadFirmRoute = {
  path: '/downloadFirm',
  name: 'Download Firm',
  invisible: true,
  component: FirmDownloadPage,
  layout: tempLayout,
};

const demoRoute = {
  path: '/demo',
  name: 'Demo Overview',
  rtlName: 'لوحة القيادة',
  invisible: true,
  component: DemoPage,
  layout: tempLayout,
  excludeFooter: true,
};

const accountsRoute = {
  path: '/accounts',
  name: 'Accounts',
  invisible: true,
  component: AccountsPage,
  layout: tempLayout,
};

const dropdownsRoute = {
  path: '/dropdowns',
  name: 'Dropdown Editor',
  invisible: true,
  component: DropdownPage,
  layout: tempLayout,
};

const accountRoute = {
  path: '/account',
  name: 'Account Overview',
  invisible: true,
  component: AccountPage,
  layout: tempLayout,
};

const launchDemoRoute = {
  path: '/launchDemo',
  name: 'Launch Demo',
  rtlName: 'لوحة القيادة',
  invisible: true,
  component: LaunchDemoForm,
  excludeFooter: true,
  layout: tempLayout,
};

const registerAccountRoute = {
  path: '/registerAccount',
  name: 'Register Account',
  invisible: true,
  component: RegisterAccountForm,
  excludeFooter: true,
  layout: tempLayout,
};

const firmTwilioInfoRoute = {
  path: '/firmTwilioInfo',
  name: 'Twilio Info',
  invisible: true,
  component: TwilioInfoPage,
  excludeFooter: true,
  layout: tempLayout,
};

const firmCallRailInfoRoute = {
  path: '/firmCallRailInfo',
  name: 'CallRail Info',
  invisible: true,
  component: CallRailInfoPage,
  excludeFooter: true,
  layout: tempLayout,
};

const initialCallFormRoute = {
  path: '/newProspectPage',
  name: 'Initial Call Form',
  rtlName: 'لوحة القيادة',
  icon: CallFormIcon,
  invisible: true,
  component: NewProspectPage,
  excludeFooter: true,
  layout: tempLayout,
};

const prospectsRoute = {
  path: '/prospects',
  name: 'Prospects',
  icon: PeopleIcon,
  component: ProspectsPage,
  excludeFooter: true,
  layout: tempLayout,
};

const clientsRoute = {
  path: '/clients',
  name: 'Active Clients',
  icon: PersonIcon,
  component: ClientsPage,
  excludeFooter: true,
  layout: tempLayout,
};

const alumRoute = {
  path: '/alumni',
  name: 'Alumni',
  icon: AlumIcon,
  component: AlumPage,
  excludeFooter: true,
  layout: tempLayout,
};

const referrerOrgsRoute = {
  path: '/referrerOrgs',
  name: 'Referral Companies',
  icon: ReferrersIcon,
  component: ReferrerOrgsPage,
  excludeFooter: true,
  layout: tempLayout,
};

const referrerOrgRoute = {
  path: '/referrerOrg',
  name: 'Referrer Org',
  icon: ReferrersIcon,
  invisible: true,
  component: ReferrerOrgPage,
  excludeFooter: true,
  layout: tempLayout,
};

const referrerContactsRoute = {
  path: '/referrerContacts',
  name: 'Referral Contacts',
  icon: ReferrersIcon,
  component: ReferrerContactsPage,
  excludeFooter: true,
  layout: tempLayout,
};

const campaignsRoute = {
  path: '/campaigns',
  name: 'Campaigns',
  icon: CampaignsIcon,
  component: CampaignsPage,
  excludeFooter: true,
  layout: tempLayout,
};

const referralReportRoute = {
  path: '/referralReport',
  name: 'Referral Report',
  component: ReferralReportPage,
  excludeFooter: true,
  layout: '/u',
};

const activityReportRoute = {
  path: '/activityReport',
  name: 'Activity Report',
  component: ActivityReportPage,
  excludeFooter: true,
  layout: '/u',
};

const reportsRoute = {
  name: 'Reports',
  icon: ReportsIcon,
  component: ReferralReportPage,
  excludeFooter: true,
  layout: tempLayout,
  collapse: true,
  views: [referralReportRoute, activityReportRoute],
};

const inquiriesRoute = {
  path: '/leads',
  name: 'Leads',
  icon: LeadsIcon,
  component: InquiriesPage,
  excludeFooter: true,
  layout: tempLayout,
};

const referrerContactRoute = {
  path: '/referrerContact',
  name: 'Referrer Contact',
  icon: ReferrersIcon,
  invisible: true,
  component: ReferrerContactPage,
  excludeFooter: true,
  layout: tempLayout,
};

const emergencyContactRoute = {
  path: '/emergencyContact',
  name: 'Emergency Contact',
  invisible: true,
  component: EmergencyContactPage,
  excludeFooter: true,
  layout: tempLayout,
};

const caseRoute = {
  path: '/case',
  name: 'Case',
  rtlName: 'لوحة القيادة',
  icon: CaseIcon,
  invisible: true,
  component: CasePage,
  excludeFooter: true,
  layout: tempLayout,
};

const showClientRoute = {
  path: '/showClient',
  name: 'Show Client',
  component: ShowClientPage,
  invisible: true,
  layout: tempLayout,
};

const referralRoute = {
  path: '/referral',
  name: 'Referral',
  invisible: true,
  component: ReferralPage,
  excludeFooter: true,
  layout: tempLayout,
};

const inquiryRoute = {
  path: '/lead',
  name: 'Lead',
  invisible: true,
  component: InquiryPage,
  excludeFooter: true,
  layout: tempLayout,
};

const callLogRoute = {
  path: '/callLog',
  name: 'Call Log',
  icon: InquiriesIcon,
  component: CallLogPage,
  excludeFooter: true,
  layout: tempLayout,
};

const play01Route = {
  path: '/allevaPlay01',
  name: 'Alleva Play 01',
  rtlName: 'لوحة القيادة',
  icon: PlayIcon,
  component: AllevaPlay01Page,
  layout: tempLayout,
};

const kimsExperimentPage = {
  path: '/kimsDangerousPage',
  name: `Kim's Experiments`,
  invisible: true,
  component: KimsExperimentPage,
  layout: tempLayout,
};

const layoutPractice01Route = {
  path: '/layoutPractice01',
  name: 'Layout Practice 01',
  rtlName: 'لوحة القيادة',
  icon: PracticeIcon,
  component: LayoutPractice01,
  layout: tempLayout,
};

const configureEmrSyncRoute = {
  path: '/configureEmrSync',
  name: 'Configure EMR Sync',
  component: ConfigureEmrSyncPage,
  invisible: true,
  layout: tempLayout,
};

const visitorRoutes = [];
const userRoutes = [];
const allevaRepRoutes = [];
const superAdminRoutes = [];
const localhostRoutes = [];
const devModeRoutes = [];
const devRoutes = [];

visitorRoutes.push(strangerHomeRoute);
visitorRoutes.push(loginRoute);

userRoutes.push(homeRoute);
userRoutes.push(logoutRoute);
userRoutes.push(userProfileRoute);
userRoutes.push(settingsRoute);
userRoutes.push(callLogRoute);
userRoutes.push(inquiriesRoute);
userRoutes.push(initialCallFormRoute);
userRoutes.push(prospectsRoute);
userRoutes.push(clientsRoute);
userRoutes.push(alumRoute);
userRoutes.push(referrerOrgsRoute);
userRoutes.push(referrerOrgRoute);
userRoutes.push(referrerContactsRoute);
userRoutes.push(campaignsRoute);
userRoutes.push(reportsRoute);
userRoutes.push(referrerContactRoute);
userRoutes.push(emergencyContactRoute);
userRoutes.push(caseRoute);
userRoutes.push(showClientRoute);
userRoutes.push(referralRoute);
userRoutes.push(inquiryRoute);
userRoutes.push(dropdownsRoute);
// userRoutes.push(play01Route);

allevaRepRoutes.push(homeRoute);
allevaRepRoutes.push(logoutRoute);
allevaRepRoutes.push(userProfileRoute);
allevaRepRoutes.push(settingsRoute);
allevaRepRoutes.push(demosRoute);
allevaRepRoutes.push(demoRoute);
allevaRepRoutes.push(launchDemoRoute);
allevaRepRoutes.push(registerAccountRoute);

superAdminRoutes.push(homeRoute);
superAdminRoutes.push(logoutRoute);
superAdminRoutes.push(userProfileRoute);
superAdminRoutes.push(saProfileRoute);
superAdminRoutes.push(settingsRoute);
superAdminRoutes.push(demosRoute);
superAdminRoutes.push(spreadsheetUploadRoute);
superAdminRoutes.push(downloadFirmRoute);
superAdminRoutes.push(demoRoute);
superAdminRoutes.push(accountsRoute);
superAdminRoutes.push(dropdownsRoute);
superAdminRoutes.push(accountRoute);
superAdminRoutes.push(launchDemoRoute);
superAdminRoutes.push(registerAccountRoute);
superAdminRoutes.push(firmTwilioInfoRoute);
superAdminRoutes.push(firmCallRailInfoRoute);
superAdminRoutes.push(clearStorageRoute);
superAdminRoutes.push(configureEmrSyncRoute);

localhostRoutes.push(homeRoute);
localhostRoutes.push(loginRoute);
localhostRoutes.push(devModeRoute);

devModeRoutes.push(homeRoute);
devModeRoutes.push(loginRoute);
devModeRoutes.push(logoutRoute);
devModeRoutes.push(userProfileRoute);
devModeRoutes.push(saProfileRoute);
devModeRoutes.push(settingsRoute);
devModeRoutes.push(callLogRoute);
devModeRoutes.push(inquiriesRoute);
devModeRoutes.push(prospectsRoute);
devModeRoutes.push(clientsRoute);
devModeRoutes.push(alumRoute);
devModeRoutes.push(referrerOrgsRoute);
devModeRoutes.push(referrerOrgRoute);
devModeRoutes.push(referrerContactsRoute);
devModeRoutes.push(campaignsRoute);
devModeRoutes.push(referrerContactRoute);
devModeRoutes.push(emergencyContactRoute);
devModeRoutes.push(caseRoute);
devModeRoutes.push(referralRoute);
devModeRoutes.push(inquiryRoute);
devModeRoutes.push(play01Route);
devModeRoutes.push(kimsExperimentPage);
devModeRoutes.push(layoutPractice01Route);
devModeRoutes.push(accountsRoute);
devModeRoutes.push(dropdownsRoute);
devModeRoutes.push(accountRoute);
devModeRoutes.push(demosRoute);
devModeRoutes.push(spreadsheetUploadRoute);
devModeRoutes.push(downloadFirmRoute);
devModeRoutes.push(demoRoute);
devModeRoutes.push(launchDemoRoute);
devModeRoutes.push(registerAccountRoute);
devModeRoutes.push(firmTwilioInfoRoute);
devModeRoutes.push(firmCallRailInfoRoute);
devModeRoutes.push(clearStorageRoute);
devModeRoutes.push(configureEmrSyncRoute);

devRoutes.push(homeRoute);
devRoutes.push(loginRoute);
devRoutes.push(logoutRoute);
devRoutes.push(userProfileRoute);
devRoutes.push(saProfileRoute);
devRoutes.push(settingsRoute);
devRoutes.push(devModeRoute);
devRoutes.push(demosRoute);
devRoutes.push(spreadsheetUploadRoute);
devRoutes.push(downloadFirmRoute);
devRoutes.push(demoRoute);
devRoutes.push(launchDemoRoute);
devRoutes.push(registerAccountRoute);
devRoutes.push(firmTwilioInfoRoute);
devRoutes.push(firmCallRailInfoRoute);
devRoutes.push(referrerOrgRoute);
devRoutes.push(referrerContactRoute);
devRoutes.push(emergencyContactRoute);
devRoutes.push(play01Route);
devRoutes.push(kimsExperimentPage);
devRoutes.push(layoutPractice01Route);
devRoutes.push(accountsRoute);
devRoutes.push(dropdownsRoute);
devRoutes.push(accountRoute);
devRoutes.push(clearStorageRoute);
devRoutes.push(configureEmrSyncRoute);

const getAppropriateRoutes = (layoutName) => {
  switch (layoutName) {
    case 'Admin':
      return mapLayout(userRoutes, '/a');
    case 'AllevaRep':
      return mapLayout(allevaRepRoutes, '/ar');
    case 'Dev':
      return mapLayout(devRoutes, '/dev');
    case 'DevMode':
      return mapLayout(devModeRoutes, '/dm');
    case 'SuperAdmin':
      return mapLayout(superAdminRoutes, '/sa');
    case 'User':
      return mapLayout(userRoutes, '/u');
    case 'Plain':
    default:
      return mapLayout(visitorRoutes, '/p');
  }
};

const mapLayout = (routes, layoutPrefix) => {
  return routes.map((route) => {
    if (route.collapse) {
      mapLayout(route.views, layoutPrefix);
    }
    return { ...route, layout: layoutPrefix };
  });
};

export default getAppropriateRoutes;
